/**
 * Auth types and enums.
 * This file exists to break circular dependencies between brightback-auth.slice.ts and brightback-auth.ts
 */

import {
  type ChargebeeGetSignInUrlArgs,
  type ChargebeeSignInArgs,
} from '@bbkAdminUtils/auth-chargebee';
import { type DevSignInArgs } from '@bbkAdminUtils/auth-dev';

export enum SignInType {
  'DEV' = 'DEV',
  'CHARGEBEE' = 'CHARGEBEE',
}

export type SignInTokens = {
  type: SignInType;
  access_token: string;
  refresh_token: string;
  exp: number; // expires at
};

export type SignInArgs =
  | ({
      type: SignInType.DEV;
    } & DevSignInArgs)
  | ({
      type: SignInType.CHARGEBEE;
    } & ChargebeeSignInArgs);

export type GetSignInUrlArgs = {
  type: SignInType.CHARGEBEE;
} & ChargebeeGetSignInUrlArgs;
